module.exports = __webpack_public_path__ + "img/close-nav.d89a0ee7.svg";